module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValues.0d2bc421.mp3";